export const Lista_Gravedad = [
    "No es grave",
    "Puede ser grave pero lo puedo controlar",
    "Puede llegar a ser muy grave"
] as const;